import { SpecialGiftCreate } from 'components/general-settings/special-gift-create/SpecialGiftCreate'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_SPECIAL_GIFT } from 'services/apiSpecialGift'
import { constructOptionMultipleSelect, convertErrorMessage, getValueFromArray, uploadFileToS3 } from 'utils/utils'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    name: null,
    desktop_image_url: null,
    mobile_image_url: null,
    minimum_purchase: null,
    maximum_purchase: null,
    gift_ids: [],
}

const GET_FIELD_NAME = {
    name: 'Nama special gift',
    minimum_purchase: 'Minimum pembelanjaan',
    gift_ids: 'Product gift',
}

const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    desktop_image_url: 'Banner gift desktop',
    mobile_image_url: 'Banner gift mobile',
    maximum_purchase: 'Maksimal pembelanjaan',
}

export const SpecialGiftCreateContainer = () => {
    const navigate = useNavigate()
    const [specialGiftDetail, setSpecialGiftDetail] = useState({})
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [searchParams] = useSearchParams()
    const giftId = searchParams.get('giftId')
    const { fetching: getSpecialGiftDetail, isLoading } = useFetch(API_SPECIAL_GIFT.DETAIL)
    const { fetching: getGiftList } = useFetch(API_SPECIAL_GIFT.GIFT_LIST)
    const { fetching: getUrlBannerImages } = useFetch(API_SPECIAL_GIFT.URL_BANNER_IMAGES)
    const { fetching: createSpecialGift, isLoading: isCreating } = useFetch(API_SPECIAL_GIFT.CREATE)
    const { fetching: updateSpecialGift, isLoading: isUpdating } = useFetch(API_SPECIAL_GIFT.UPDATE)
    const [optionsGift, setOptionsGift] = useState([])
    const [errorForm, setErrorForm] = useState({})

    const onChangeForm = (e) => {
        const { name, value } = e
        setSpecialGiftDetail({ ...specialGiftDetail, [name]: value })
    }

    const onSearchGift = (keyword) => {
        getGiftList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsGift(newList)
        })
    }

    const validateForm = () => {
        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(specialGiftDetail).forEach((key) => {
                if (
                    GET_FIELD_NAME[key] &&
                    (!specialGiftDetail[key]?.toString() || specialGiftDetail[key]?.length === 0)
                ) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (
                    key === 'desktop_image_url' &&
                    !specialGiftDetail?.[key] &&
                    specialGiftDetail?.mobile_image_url
                ) {
                    errors[key] = 'Banner gift desktop wajib diisi'
                } else if (
                    key === 'mobile_image_url' &&
                    !specialGiftDetail?.[key] &&
                    specialGiftDetail?.desktop_image_url
                ) {
                    errors[key] = 'Banner gift mobile wajib diisi'
                }
            })
            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const setShowAlert = (message) => {
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const setUploadBannerImages = async (filesName, uploadDetail) => {
        const newSpecialGiftDetail = { ...specialGiftDetail }

        try {
            const s3Urls = await getUrlBannerImages({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newSpecialGiftDetail[uploadDetail[i]?.key] = `${item?.url}${item?.fields?.key}`
            })
            await Promise.all(apiS3list)
            onSave(newSpecialGiftDetail)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const bannerImages = [specialGiftDetail?.desktop_image_url, specialGiftDetail?.mobile_image_url]
            const uploadDetail = []
            const filesName = []

            bannerImages.map((item, index) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({ file: item?.file, key: index === 0 ? 'desktop_image_url' : 'mobile_image_url' })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBannerImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...specialGiftDetail }) => {
        const newPayload = {
            ...payload,
            minimum_purchase: payload?.minimum_purchase ? Number(payload?.minimum_purchase) : null,
            maximum_purchase: payload?.maximum_purchase ? Number(payload?.maximum_purchase) : null,
            gift_ids: getValueFromArray(payload?.gift_ids, 'value'),
        }

        if (!giftId) {
            createSpecialGift(newPayload)
                .then(() => {
                    setShowAlert('Special Gift Created !')
                    navigate('/general-setting/special-gift-list')
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        } else {
            updateSpecialGift(newPayload, giftId)
                .then(() => {
                    setShowAlert('Special Gift Updated !')
                    navigate('/general-setting/special-gift-list')
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        }
    }

    useEffect(() => {
        if (giftId) {
            getSpecialGiftDetail({}, giftId).then((response) => {
                const { gifts, ...data } = { ...response?.data }
                const newDetail = {
                    ...data,
                    gift_ids: constructOptionMultipleSelect(gifts, 'name', 'id', 'image_url'),
                }
                setSpecialGiftDetail(newDetail)
            })
        } else {
            setSpecialGiftDetail(INITIAL_STATE)
        }
        setErrorForm({})
    }, [giftId])

    const props = {
        specialGiftDetail,
        isLoadingUpload,
        onChangeForm,
        onSearchGift,
        optionsGift,
        isLoading,
        isCreating,
        isUpdating,
        errorForm,
        onSubmit,
    }

    return <SpecialGiftCreate {...props} />
}
